import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 650,
    width: "100%",
    "& th[scope='row'] a": {
      display: "block",
      fontSize: theme.typography.h3.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  th: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightLight,
  },
}))

export default function SimpleTable({ titles, rows }) {
  const classes = useStyles()

  return (
    <TableContainer className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead size="small">
          <TableRow>
            {titles.map((cell, colIndex) => (
              <TableCell
                key={colIndex}
                align={colIndex ? "right" : "left"}
                className={classes.th}
                component="th"
                scope="col"
                size="small"
                width={cell.width ? cell.width : ""}
              >
                {cell.content}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((column, colIndex) => {
                return <TableCell key={colIndex} component={!colIndex ? "th" : ""} scope={!colIndex ? "row" : ""} align={colIndex ? "right" : "left"}>{column.content}</TableCell>
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
